import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (data?.empresa === null || data?.empresa === undefined)
        response.push(<Box>Selecione uma empresa.</Box>)

    if (data?.rename === '')
        response.push(<Box>Digite o rename.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData